/** Compact location cell for the contacts table. */
export function formatContactLocations(names) {
    const list = (Array.isArray(names) ? names : []).filter(Boolean);
    if (list.length === 0) return "—";
    if (list.length === 1) return list[0];
    return `${list.length} locations`;
}

/** Full location names for tooltip when the cell is compacted. */
export function formatContactLocationsTitle(names) {
    const list = (Array.isArray(names) ? names : []).filter(Boolean);
    return list.join(", ");
}
